import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';
import SlotService from '../cart-process/slot.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import SlotModel from '../models/slot.model';
import CustomerDetailsService from '../cart-process/customer-details.service';
import { YourOfferService } from '../cart-process/your-offer.service';
import { ExternalInterfacesEnum, ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';
import { ICartDetails, ISummaryPrice } from '../interfaces/cart-details.interface';
import { SubmitOrderService } from '../order-fulfillment/submit-order.service';
import { IExtendedAdditionalBundleSet } from '../interfaces/additional-bundles.interface';
import { DataLayerService } from '../customer-actions/data-layer.service';
import AccessoriesService from '../cart-process/accessories.service';

declare const window: any;
declare const P4: any;

@Component({
  selector: 'page-offer-view',
  templateUrl: './page-offer-view.component.html',
})
export class PageOfferViewComponent implements OnInit, AfterViewInit {

  public linkNext: string;
  public slots: SlotModel[];
  public additionalBundles: IExtendedAdditionalBundleSet[];
  private summaryPrices: ISummaryPrice[];

  constructor(
    public yourOffer: YourOfferService,
    public commonInfo: CommonInfoService,
    private elementRef: ElementRef,
    private slotService: SlotService,
    private customerDetailsService: CustomerDetailsService,
    private notificationProviderService: NotificationProviderService,
    private externalInterfacesService: ExternalInterfacesService,
    private submitOrderService: SubmitOrderService,
    private dataLayerService: DataLayerService,
    public accessoriesService: AccessoriesService
  ) {
    this.externalInterfacesService.getData(ExternalInterfacesEnum.CART_DETAILS);

    this.customerDetailsService.get();

    this.linkNext = this.elementRef.nativeElement.getAttribute('link-next');

    window.reloadCartDetailsInnerNg2 = this.externalInterfacesService.updateCartDetails.bind(this.externalInterfacesService);

    this.submitOrderService.storeCartStep().clear();
    this.submitOrderService.storeFormData().clear();
  }

  ngOnInit(): void {
    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.slots = this.slotService.getSlots();
        this.additionalBundles = this.slotService.getAdditionalBundles();
        this.summaryPrices = cartDetails.summaryPrices;
      }
    });

    this.dataLayerService.cartViewCheckout(this.summaryPrices, this.slots);
  }

  ngAfterViewInit(): void {
    P4.modules.stickyElements.init();
  }

  public get showDiscountBar() {
    const requiredParticipants = this.commonInfo.simCardDiscount?.requiredParticipants;
    return this.commonInfo.isNextSim && this.commonInfo.simCardDiscount && this.commonInfo.currentlyProcessed + this.slots.length >= requiredParticipants && this.commonInfo.currentlyProcessed === requiredParticipants - 1;
  }
}
